import { useMemo } from 'react';
import { useQueryParams } from 'hooks/useQueryParams';
import { MembershipQueryParams } from '../../membership.types';
import {
  MembershipAccountInfoQueryParams,
  MembershipExternalSuccessQueryParams,
  parseMembershipAccountInfoQueryParams,
  parseMembershipExternalSuccessQueryParams,
  parseMembershipSuccessQueryParams,
} from './useMembershipUrlParams.utils';

export const useMembershipAccountInfoQueryParams =
  (): MembershipAccountInfoQueryParams => {
    const [queryParams] = useQueryParams<MembershipQueryParams>();

    return useMemo(
      () => parseMembershipAccountInfoQueryParams(queryParams),
      [queryParams],
    );
  };

export const useMembershipExternalSuccessQueryParams =
  (): MembershipExternalSuccessQueryParams => {
    const [queryParams] = useQueryParams<MembershipQueryParams>();

    return useMemo(
      () => parseMembershipExternalSuccessQueryParams(queryParams),
      [queryParams],
    );
  };

export const useMembershipSuccessQueryParams = (): { upgrade: boolean } => {
  const [queryParams] = useQueryParams<MembershipQueryParams>();

  return useMemo(
    () => parseMembershipSuccessQueryParams(queryParams),
    [queryParams],
  );
};
